export default function AboutSection() {
  return (
    <section id="about" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-4">
            <i className="ri-information-line"></i>
            关于平台
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
            91吃瓜爆料网创立于对娱乐真相的执着追求。作为国内领先的吃瓜群众专属资讯聚合平台，我们致力于打破信息壁垒，为每一位热爱追踪娱乐圈动态的用户提供最及时、最全面、最深度的爆料内容。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
            从明星恋情到综艺内幕，从影视爆料到资本暗战，我们的采编团队7×24小时监控全网50余个核心信源，确保每一条重磅消息都能第一时间触达你的指尖。我们相信，优质的吃瓜内容不仅需要速度，更需要深度——这正是91吃瓜爆料网区别于其他平台的核心竞争力。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            无论你是追踪娱乐圈多年的资深吃瓜群众，还是刚刚开启八卦之旅的新朋友，91吃瓜爆料网都将是你最值得信赖的专属入口。加入百万吃瓜大军，不错过任何一个精彩瞬间。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 mt-7 pt-6 border-t border-background-200/70">
            <div className="text-center">
              <div className="text-xl font-heading text-primary-600">3年</div>
              <div className="text-xs text-foreground-500">深耕吃瓜领域</div>
            </div>
            <div className="text-center">
              <div className="text-xl font-heading text-primary-600">50+</div>
              <div className="text-xs text-foreground-500">核心信源覆盖</div>
            </div>
            <div className="text-center">
              <div className="text-xl font-heading text-primary-600">100万+</div>
              <div className="text-xs text-foreground-500">吃瓜群众信赖</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}